import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import Link from '../../common/TrackedLink';
import ButtonLink from "../../common/TrackedButtonLink";

class Certification extends Component {
	render() {
		return (
			<section className="row certification">
				<div className="col">
					<h2>{ this.props.header }</h2>
				</div>
				<div className="col descr">
					<p>{ renderHTML(this.props.subHeader) }</p>
				</div>
				<div className="row">
					<div className="col sm-6">
						<div className="icon">
							<img
								src={ this.props.imgSrc1 }
								alt={ this.props.alt1 }
							/>
						</div>
						<h3>{ renderHTML(this.props.title1) }</h3>
						<p>{ renderHTML(this.props.content1) }</p>
						{this.props.link1Url && this.props.link1Text &&
							<Link
								className="arrow-link"
								to={ this.props.link1Url }
							>
								{ this.props.link1Text }
							</Link>
						}
					</div>
					<div className="col sm-6">
						<div className="icon">
							<img
								src={ this.props.imgSrc2 }
								alt={ this.props.alt2 }
							/>
						</div>
						<h3>{ renderHTML(this.props.title2) }</h3>
						<p>{ renderHTML(this.props.content2) }</p>
						{this.props.link2Url && this.props.link2Text &&
						<Link
							className="arrow-link"
							to={ this.props.link2Url }
						>
							{ this.props.link2Text }
						</Link>
						}
					</div>
				</div>
				{!this.props.link2Url &&
				<div className="d-flex justify-content-center pt-5 pb-5 mb-2">
					<ButtonLink
						className="btn-primary"
						to="https://insights.masterlock.com/articles/5-things-you-need-to-know-about-your-safes-fire-rating"
						target="_blank">
						About our Tests
					</ButtonLink>
				</div>
				}
			</section>
		);
	}
}

export default Certification;


// WEBPACK FOOTER //
// ./src/pages/category/common/Certification.js